import React, { useState, useRef } from "react";
import { FormWrapper } from "./FormWrapper";
import { AddAndCloseButton } from "../generic/AddAndCloseButton";
import { AddAndContinueButton } from "../generic/AddAndContinueButton";
import { CloseButton } from "../generic/CloseButton";

export const AddProduct = ({ onClose, onSubmit }) => {
  const [newProduct, setNewProduct] = useState({});
  const nameRef = useRef(null);

  return (
    <FormWrapper>
      <div
        style={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "1rem",
          }}
        >
          <h3 style={{ margin: "0 auto" }}>Neues Produkt</h3>
          <input
            ref={nameRef}
            type="text"
            id="name"
            value={newProduct.name || ""}
            onChange={(e) =>
              setNewProduct({ ...newProduct, name: e.target.value })
            }
            style={{ fontSize: "1.5rem" }}
            autoFocus
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                onSubmit(newProduct);
              }
            }}
          />
          <div style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
            <label style={{ fontWeight: "bold" }}>Menge</label>
            <input
              type="number"
              id="amount"
              value={newProduct.amount || ""}
              onChange={(e) =>
                setNewProduct({ ...newProduct, amount: e.target.value })
              }
              style={{ fontSize: "1.5rem", width: "100%" }}
              // this is hacky, should use propper html form onsubmit instead
              inputMode="text"
              enterKeyHint="done"
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  onSubmit(newProduct);
                }
              }}
            />
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
            <label style={{ fontWeight: "bold" }}>Einheit</label>
            <select
              autoComplete
              id="unit"
              value={newProduct.unit || ""}
              onChange={(e) =>
                setNewProduct({ ...newProduct, unit: e.target.value })
              }
              style={{ fontSize: "1.5rem", width: "100%" }}
            >
              <option value=""></option>
              <option value="Gramm">Gramm</option>
              <option value="Kilo">Kilo</option>
              <option value="Liter">Liter</option>
            </select>
          </div>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "1rem",
            marginTop: "2rem",
          }}
        >
          <AddAndCloseButton
            disabled={!newProduct.name}
            onClick={() => onSubmit(newProduct, true)}
          />
          <AddAndContinueButton
            disabled={!newProduct.name}
            onClick={() => {
              onSubmit(newProduct);
              setNewProduct({});
              nameRef.current?.focus();
            }}
          />
          <CloseButton onClick={onClose} />
        </div>
      </div>
    </FormWrapper>
  );
};
